import { useTranslation } from 'react-i18next';

import { ErrorPage } from './ErrorPage';

export function Page404() {
  const { t } = useTranslation();
  return (
    <ErrorPage
      code="404"
      title={t('system.page404.title')}
      body={t('system.page404.body')}
      ctaLabel={t('system.page404.cta')}
      ctaTo="/"
    />
  );
}
